import { useExamCenter } from '@exam-center/exam-center-details';
import { useGetIctExamEventYearsByExamCenterCodeQuery } from '@exam-center/graphql';
import { useNavigate, useParams } from '@exam-center/router';
import { Selection } from '@shared/components';
import { dayjs } from '@shared/utils';

import { getExamEventYearsSelectionOptions } from '../../utils';

const currentYear = dayjs().year();

export default function ExamEventYearSelection() {
  const { year } = useParams('/:examCenterCode/exam-events/years/:year');
  const { examCenter } = useExamCenter();

  const navigate = useNavigate();

  const { data } = useGetIctExamEventYearsByExamCenterCodeQuery({
    variables: {
      getICTExamEventYearsByExamCenterCodeInput: {
        examCenterCode: examCenter.code,
      },
    },
  });

  const existingYears = data?.ecGetICTExamEventYearsByExamCenterCode.ictExamYears ?? [];

  const yearOptions = getExamEventYearsSelectionOptions(existingYears, currentYear);

  const handleYearChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const selectedYear = event.target.value;
    navigate('/:examCenterCode/exam-events/years/:year', {
      params: { examCenterCode: examCenter.code, year: selectedYear },
    });
  };

  return <Selection value={parseInt(year)} options={yearOptions} onChange={handleYearChange} />;
}
